import React, { useState } from 'react';
import { Modal, Input, Button, Form, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useDataContext } from '../../contexts/DataContext';

const LoginModal: React.FC = () => {
  const { login, isAuthenticated } = useDataContext();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleLogin = async (values: { password: string }) => {
    setLoading(true);
    try {
      await login(values.password);
      message.success('Успешный вход');
    } catch (error) {
      message.error('Неверный пароль');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Вход в систему"
      open={!isAuthenticated}
      footer={null}
      closable={false}
      maskClosable={false}
      centered
    >
      <Form
        form={form}
        onFinish={handleLogin}
        layout="vertical"
      >
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Пожалуйста, введите пароль' }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Пароль"
            size="large"
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block size="large" loading={loading}>
            Войти
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default LoginModal;
